import { formatNumber } from '../../lib/utils';

export const DashboardHeader = ({ ethPrice }) => (
  <div className="flex items-center justify-between">
    <div>
      <h1 className="text-3xl sm:text-4xl font-bold mb-2">Taiboku Explorer</h1>
      <p className="text-muted-foreground">Multichain block explorer · KROWN, Solana &amp; EVM analytics</p>
    </div>
    {ethPrice && (
      <div className="text-right hidden sm:block">
        <p className="text-xs text-muted-foreground">ETH/USD</p>
        <p className="text-lg font-mono font-bold">${formatNumber(ethPrice.eth_price_usd?.toFixed(2) || '0')}</p>
      </div>
    )}
  </div>
);
